export const GET_POLICIES = '[Policy Action] Get Policies';
export const CONFIRMED_GET_POLICIES = '[Policy Action] Confirmed Get Policies';
